import { z } from "zod";

import { Availability } from "../commons/user";

export const updateBodySchema = z.object({
  availability: z.nativeEnum(Availability),
});

export type AvailabilityPayload = z.infer<typeof updateBodySchema>;

export const updateRequestSchema = z.object({
  body: updateBodySchema,
});

export type UpdateRequest = z.infer<typeof updateRequestSchema>;

export const updateResponseSchema = z.object({
  availability: z.string(),
});

export type UpdateResponse = z.infer<typeof updateResponseSchema>;
